import styled from 'styled-components';

// ##### Estilos #####
export const NavContainer = styled.nav`
  @media (max-width: 1023px) {
    display: ${(props) => (props.shownav ? 'block' : 'none')};
  }
`;

export const Ul = styled.ul`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  margin: 0;
  padding: 0.5rem 5rem;
`;

export const Li = styled.li`
  padding: 0rem 2rem;
  border-right: 2px solid #fff;
`;

export const Accesibilidad = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 1.5rem;
  margin-left: 2rem;
  overflow: hidden;
`;

export const AccButton = styled.button`
  border: none;
  padding: 0 1rem;
  font-size: 20;
  font-weight: 700;
  background-color: #fff;
  color: #03323c;

  &:active {
    background-color: ${(props) => props.active};
    color: #fff;
  }
`;

export const P = styled.p`
  margin: auto 0;
  padding: 0.5rem 1rem;
  font-size: 14;
  font-weight: 700;
`;
